/* ROTAS69 — вынесено из snippets/product-grid.liquid.
   Инлайном этот код уезжал в HTML каждой страницы вместе с комментариями;
   assets/*.js Shopify минифицирует и комментарии срезает, а файл кэшируется
   между страницами. Замерено: вынос пяти таких блоков из r69-judgeme дал
   -3..-4 КБ brotli на страницу. Логика не менялась. */

/* Одноколоночный режим на телефоне делает карточку вдвое шире (замер: 191 -> 390 css px),
   поэтому картинке нужен вдвое больший кандидат. Liquid отдаёт sizes для сетки по
   умолчанию (две колонки, мобильная доля 50vw); здесь мобильная доля поднимается до
   100vw, если сохранён режим mobile-single. Десктопные брейкпоинты не трогаются —
   меняется только последнее правило. Та же функция есть в assets/results-list.js:
   она вызывается при переключении, эта — при восстановлении из сессии.
   Файл подключён как обычный скрипт с defer, не модуль, поэтому без export. */
(() => {
              const applyGridImageSizes = (single) => {
                document.querySelectorAll('.product-grid img[sizes]').forEach((img) => {
                  if (!img.dataset.r69Sizes) img.dataset.r69Sizes = img.getAttribute('sizes') || '';
                  const base = img.dataset.r69Sizes;
                  if (!base) return;
                  const next = single ? base.replace(/,\s*\d+vw\s*$/, ', 100vw') : base;
                  if (img.getAttribute('sizes') === next) return;
                  img.setAttribute('sizes', next);
                  // Уже загруженную картинку смена sizes не перевыбирает — переприсваивание
                  // srcset перевыбирает. Нужно только для одной колонки (см. results-list.js).
                  if (single) img.srcset = img.srcset;
                });
              };

              const grid = document.querySelector('.product-grid');
              if (!grid) return;

              const storedLayoutMobile = sessionStorage.getItem('product-grid-view-mobile') || 'default';
              const storedLayoutDesktop = sessionStorage.getItem('product-grid-view-desktop') || 'default';

              // No need to read the window width if no custom layouts were saved.
              if (storedLayoutMobile === 'default' && storedLayoutDesktop === 'default') return;

              const storedLayout = window.innerWidth >= 750 ? storedLayoutDesktop : storedLayoutMobile;
              if (storedLayout === 'default') return;

              grid.setAttribute('product-grid-view', storedLayout);
              applyGridImageSizes(storedLayout === 'mobile-single');

              const options = document.querySelectorAll(
                'input[type="radio"][name="grid"], input[type="radio"][name="grid-mobile"]'
              );
              for (const option of options) {
                option.checked = option.value === storedLayout;
              }
            })();
